import { faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";

export type Props = {
  onRequestAddFolder: () => void;
};

export const AddFolder: React.FC<Props> = ({ onRequestAddFolder }) => {
  return (
    <button
      className="sticky bottom-0 flex w-[203px] items-center justify-start rounded-lg bg-white px-2 py-1.5 text-indigo-600 hover:bg-gray-50 focus-visible:outline-none"
      data-loc="add-folder"
      onClick={onRequestAddFolder}
    >
      <div className="pr-1.5">
        <Icon icon={faPlus} size="xs" />
      </div>
      <span className="grow truncate text-left font-inter-medium-13px">
        Add folder
      </span>
    </button>
  );
};
